#version 300 es
precision highp float;

uniform sampler2D u_screen;
uniform float u_opacity;

in vec2 v_tex_pos;
out vec4 outColor;

void main(){
    vec4 color=texture(u_screen,1.-v_tex_pos);
    // a hack to guarantee opacity fade out even with a value close to 1.0
    outColor=vec4(floor(255.*color*u_opacity)/255.);
}
